import { z } from 'zod';

export const aiEmailAssistantSchema = z.object({
  // Step 1: Subject
  messageType: z.string().nonempty('Please select a message type'),

  // Step 2: Donor
  donorContext: z.string().optional(),

  // Step 3: Organization
  organizationContext: z.string().optional(),

  // Step 4: Past Conversations
  pastConversations: z.string().optional()
});

export type AiEmailAssistantForm = z.infer<typeof aiEmailAssistantSchema>;
